let nfe_id = window.nfe_id;
let emitente_id = window.emitente_id;
let empresa_id = window.empresa_id;

function getNFeId() {
    // Always read from window to ensure the value is the one set by the page
    return window.nfe_id ?? nfe_id;
}

// Expondo as funções/utilitários como globals para acesso em scripts inline
// Isso garante que pages blade que usem @push('scripts') e chamem
// getNFeId() possam acessar a função mesmo com o bundler (mix/webpack)
window.getNFeId = getNFeId;
window.getEmitenteId = function () {
    return window.emitente_id ?? emitente_id;
};
window.getEmpresaId = function () {
    return window.empresa_id ?? empresa_id;
};



/**
 * Submit fomulário de cadastro de Emitente
 */
$("#formEmitente").submit(function (ev) {
    ev.preventDefault();
    $(".cnpj").unmask();

    var form = $(this);
    var url = form.attr("action");

    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        success: function (data) {
            //console.log(data);
            if ($("input[name=id]").val() === undefined) {
                alert("Novo emitente cadastrado com sucesso!");
            } else {
                alert("Emitente atualizado com sucesso!");
            }

            window.location = "/emitentes";
        },
        error: function (error) {
            console.error(error.responseJSON.message);
        },
    });

    $(".cnpj").mask("00.000.000/0000-00", { reverse: false });
});

/**
 * Submit formulário de cadastro de Emitente
 */
$("#formUser").submit(function (ev) {
    ev.preventDefault();

    if ($("input[name=id]").val() === undefined) {
        let conf = confirm("Cadastrar novo usuário?");
        if (!conf) {
            return;
        }
    } else {
        let conf = confirm("Confirmar alterações no usuário?");
        if (!conf) {
            return;
        }
    }

    var form = $(this);
    var url = form.attr("action");

    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        success: function (data) {
            //console.log(data);
            //alert('Usuário Cadastrado com sucesso!');
            window.location = "/users";
        },
        error: function (error) {
            alert("Erro ao cadastrar: " + error.responseJSON.message);
            //console.error(error.responseJSON.message);
        },
    });
});

function load_emitentes() {
    $.ajax({
        url: "/emitentes/all",
        type: "GET",
        success: (resp) => {
            $("#table_emitentes").DataTable({
                language: {
                    url: "/pt-br.json",
                },
                data: resp,
                searching: false,
                destroy: true,
                paging: false,
                responsive: true,
                autoWidth: false,
                //info: false,
                columns: [
                    { data: "razao_social" },
                    { data: "nome_fantasia" },
                    { data: "api_version" },
                    {
                        data: null,
                        render: function (data, type, row) {
                            if (type === 'display') {
                                return data.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
                            }
                            return data.cnpj;
                        }
                    },
                    {
                        data: null,
                        className: "text-center",
                        render: function (data, type, row, meta) {
                            if (type === "display") {
                                if (data.status == 0) {
                                    //return 'A enviar'
                                    return '<div class="text-center"><span class="badge badge-danger">Inativa</label></div>';
                                } else {
                                    //return 'Enviado'
                                    return '<div class="text-center"><span class="badge badge-success">Ativa</label></div>';
                                }
                            }
                        },
                        defaultContent: "",
                    },
                    {
                        data: null,
                        defaultContent:
                            '<button type="button" class="editEmitente btn btn-secondary btn-sm" style="color:#fff"><i class="far fa-edit"></i></button>',
                    },
                ],
            });
        },
        error: (erro) => {
            console.log(erro);
        },
    });

    $("#table_emitentes").on("click", ".editEmitente", function (ev) {
        ev.preventDefault();
        let data = $("#table_emitentes")
            .DataTable()
            .row($(this).parents("tr"))
            .data();
        window.location = "/emitente/" + data.id;
    });
}

function load_users() {
    let button =
        '<button type="button" class="editUser btn btn-info btn-sm" style="color:#fff"><i class="fas fa-user-edit"></i></button>';
    button +=
        '<button type="button" class="editUser btn btn-danger btn-sm ml-2" style="color:#fff"><i class="fas fa-user-times"></i></button>';

    $.ajax({
        url: "/users/all",
        type: "GET",
        success: (resp) => {
            $("#table_users").DataTable({
                language: {
                    url: "/pt-br.json",
                },
                data: resp,
                searching: false,
                destroy: true,
                paging: false,
                responsive: true,
                autoWidth: false,
                //info: false,
                columns: [
                    { data: "name" },
                    { data: "email" },
                    {
                        data: null,
                        className: "text-center",
                        render: function (data, type, row, meta) {
                            if (type === "display") {
                                if (data.status == 0) {
                                    //return 'A enviar'
                                    return '<div class="text-center"><span class="badge badge-danger">Inativa</label></div>';
                                } else {
                                    //return 'Enviado'
                                    return '<div class="text-center"><span class="badge badge-success">Ativa</label></div>';
                                }
                            }
                        },
                        defaultContent: "",
                    },
                    {
                        data: null,
                        className: "text-center",
                        defaultContent: button,
                    },
                ],
            });
        },
        error: (erro) => {
            console.log(erro);
        },
    });

    $("#table_users").on("click", ".btn-info", function (ev) {
        ev.preventDefault();
        let data = $("#table_users")
            .DataTable()
            .row($(this).parents("tr"))
            .data();
        window.location = "/user/" + data.id;
    });

    $("#table_users").on("click", ".btn-danger", function (ev) {
        ev.preventDefault();
        let data = $("#table_users")
            .DataTable()
            .row($(this).parents("tr"))
            .data();
        $.post("/user/remove", { id: data.id })
            .done((resp) => {
                console.log(resp);
            })
            .fail((erro) => {
                console.log(JSON.parse(erro.responseText).message);
            });
    });
}

$("#addEmitente").on("click", function (ev) {
    ev.preventDefault();
    let emitente = $("#listEmitentes").val();
    //console.log(emitente);
});

$("#cfop").on("keypress", function (ev) {
    var tecla = window.event ? ev.keyCode : ev.which;
    var texto = $(this).val();

    if (tecla == 8 || tecla == 0) return true;
    if ((tecla != 44 && tecla != 46 && tecla < 48) || tecla > 57) return false;
    if (tecla == 46) {
        return false;
    }
});

function load_etiquetas() {
    let button =
        '<button type="button" class="editUser btn btn-info btn-sm" style="color:#fff"><i class="fas fa-edit"></i></button>';
    button +=
        '<button type="button" class="editUser btn btn-danger btn-sm ml-2" style="color:#fff"><i class="fas fa-times"></i></button>';

    $.ajax({
        url: "/etiquetas/list",
        type: "GET",
        success: (resp) => {
            $("#table_etiqueta").DataTable({
                language: {
                    url: "/pt-br.json",
                },
                data: resp,
                searching: false,
                destroy: true,
                paging: false,
                responsive: true,
                autoWidth: false,
                //info: false,
                columns: [
                    { data: "id" },
                    { data: "name" },
                    {
                        data: null,
                        className: "text-right",
                        defaultContent: button,
                    },
                ],
            });
        },
        error: (erro) => {
            console.log(erro);
        },
    });

    $("#table_etiqueta").on("click", ".btn-info", function (ev) {
        ev.preventDefault();
        let data = $("#table_etiqueta")
            .DataTable()
            .row($(this).parents("tr"))
            .data();
        window.location = "/etiquetas/edit/" + data.id;
    });

    $("#table_etiqueta").on("click", ".btn-danger", function (ev) {
        ev.preventDefault();
        let data = $("#table_etiqueta")
            .DataTable()
            .row($(this).parents("tr"))
            .data();
        $.post("/etiquetas/remove", { id: data.id })
            .done((resp) => {
                console.log(resp);
                $("#table_etiqueta").DataTable().ajax.reload();
            })
            .fail((erro) => {
                alert(JSON.parse(erro.responseText).message);
                //console.log(JSON.parse(erro.responseText).message);
            });
    });
}

$(function () {
    $(".cnpj").mask("00.000.000/0000-00", { reverse: false });

    //$("#table_emitentes").DataTable({});
    load_emitentes();
    load_users();
    load_etiquetas();

    $("#listEmitentes").select2({
        placeholder: "Digite a empresa",
        language: "pt-BR",
        width: "resolve",
        ajax: {
            url: "/emitentes/all",
            dataType: "json",
            quietMillis: 150,
            minimumInputLength: 4,
            multiple: false,
            data: function (term, page) {
                //term.state = $('#select_state :selected').text();
                return term;
            },
            processResults: function (data, page) {
                return {
                    results: $.map(data, function (item) {
                        return {
                            text: item.razao_social,
                            id: item.id,
                        };
                    }),
                };
            },
        },
    });

});
